// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"270":"1e50e05a","307":"b98540cf","624":"391c22ca","977":"f8878b4f"}[chunkId] + ".chunk.css";
};